import React from "react";
import LinksContainer from "../../GeneralComponents/LinksContainer/LinksContainer";

const referenceData = [
  {
    id: 1,
    title: "Структурные подразделения",
    url: "/maintainingDirectories/structuralUnits",
  },
  { id: 2, title: "Участки ГИМС", url: "/maintainingDirectories/gimsSections" },
  {
    id: 3,
    title: "Административные районы, обслуживаемые участком",
    url: "/maintainingDirectories/administrativeDistricts",
  },
  {
    id: 4,
    title: "Должности",
    url: "/maintainingDirectories/positions",
  },
  {
    id: 5,
    title: "Наименования населенных пунктов",
    url: "/maintainingDirectories/settlements",
  },
  {
    id: 6,
    title: "Типы документов, удостоверяющих личность",
    url: "/maintainingDirectories/identification-documents",
  },
  {
    id: 7,
    title: "Типы маломерных судов",
    url: "/maintainingDirectories/boat-types",
  },
  {
    id: 8,
    title: "Виды маломерных судов",
    url: "/maintainingDirectories/kinds-boats",
  },
  {
    id: 9,
    title: "Материалы корпуса маломерного судна",
    url: "/maintainingDirectories/boatBodyMaterial",
  },
  {
    id: 10,
    title: "Типы двигателей",
    url: "/maintainingDirectories/engineType",
  },
  {
    id: 12,
    title: "Категория сложности района плавания",
    url: "/maintainingDirectories/swimmingDifficultyCategory",
  },
  {
    id: 13,
    title: "Программы подготовки судоводителей",
    url: "/maintainingDirectories/preparationPrograms",
  },
  {
    id: 14,
    title: "Виды документов об обучении",
    url: "/maintainingDirectories/trainingDocTypes",
  },
  {
    id: 15,
    title: "Медицинские показания (ограничения)",
    url: "/maintainingDirectories/medConditions",
  },
  {
    id: 16,
    title: "Реквизиты для оплаты",
    url: "/maintainingDirectories/paymentDetails",
  },
  {
    id: 17,
    title: "Диапазон регистрационных номеров МС",
    url: "/maintainingDirectories/rangeMS",
  },
  {
    id: 18,
    title: "Страны",
    url: "/maintainingDirectories/countries",
  },
  {
    id: 19,
    title: "Организации, проводившие обучение",
    url: "/maintainingDirectories/organizations",
  },
];

function MaintainingDirectories() {
  return (
    <LinksContainer
      title="Ведение справочников"
      links={referenceData}
    />
  );
}

export default MaintainingDirectories;
